export const viewTitle = "Журнал событий";
export const viewUniqKey = "event-log";
